require('./bootstrap');
require('./menu');
require('./hrefs');
// require('./pusherEvents');
require('./berichten_scroll_to_bottom');

window.Vue = require('vue');
Vue.component('upload-files', require('./components/UploadFiles.vue'));
Vue.component('remove-file', require('./components/RemoveFile.vue'));
Vue.component('rename-file', require('./components/RenameFile.vue'));
Vue.component('user-index', require('./components/UserIndex.vue'));
Vue.component('user-index-list', require('./components/UserIndexList.vue'));
Vue.component('menu-buttons', require('./components/MenuButtons.vue'));
Vue.component('menu-buttons-main', require('./components/MenuButtonsMain.vue'));
Vue.component('move-block-buttons', require('./components/MoveBlockButtons.vue'));
Vue.component('move-file-buttons', require('./components/MoveFileBlock.vue'));
Vue.component('lang-config-form', require('./components/LangConfigForm.vue'));
Vue.component('share-file-button', require('./components/ShareFileButton.vue'));

import fontawesomeIconpicker from "fontawesome-iconpicker";
import wysiwyg from "vue-wysiwyg";

Vue.use(wysiwyg);

import '@intergas/intergas-menu-modal';

import {LuminousGallery} from 'luminous-lightbox';

var galleryOpts = {showCloseButton: true};
var luminousOpts = {sourceAttribute: "hires", showCloseButton: true};


window.filterByAny = function (user, filter) {
    if (!filter) return true;
    if (user.toLowerCase().indexOf(filter.toLowerCase()) > -1) {
        console.log(user)
        console.log(filter)
        return true
    }
};

Vue.component('wysiwyg-edditor', require('./components/wysiwyg.vue'));


var app = new Vue({
    el: '#app',
    data() {
        return {
            showContacts: false,
            filter: '',
            filterByAny: window.filterByAny,
            showFileSettings: false,
            FileSettingsFileId: null,
            FileSettingsBlockId: null,
            FileSettingsShare: [],
            FileSettingsLoading: null,
        }
    },
    methods: {
        sharePhoto: function () {
            this.FileSettingsLoading = true;

            console.log('FileSettingsShare', this.FileSettingsShare);
            console.log('FileSettingsFileId', this.$root['FileSettingsFileId']);
            var formData = new FormData();
            formData.append('shareWithBlockIds', this.FileSettingsShare);
            formData.append('sourceFileId', this.FileSettingsFileId);


            axios.post('/manage/files/replicate', formData)
                .then(function (data) {
                    console.log(data.data);
                    setTimeout(function () {
                        this.FileSettingsLoading = false;
                        app.showFileSettings = false;
                        window.location.reload();
                    }.bind(this), 1500);
                }.bind(this)).catch(function (data) {
                console.log('error', data);
                alert('f');
            });
        }
    }
});

window.addEventListener('DOMContentLoaded', () => {
    intergasMenuModal();
    showLocalLogin();
});

function showLocalLogin() {
    const loginChoiceCard = document.getElementById('login-choice-card');
    const loginButton = document.getElementById('local-login');
    const loginLoginCard = document.getElementById('local-login-card');

    if (loginButton !== null) {
        loginButton.addEventListener('click', event => {
            loginChoiceCard.classList.toggle("d-none");
            loginLoginCard.classList.toggle("d-none");
        });
    }
}

function intergasMenuModal() {
    const menuModal = document.querySelector('intergas-menu-modal');
    const menuButton = document.getElementById('header-menu-button');

    if (menuButton !== null) {
        menuButton.addEventListener('click', () => {
            menuModal.setAttribute(
                'is-open', ''
            );
        });
    }

    fetch('https://api.intergas-verwarming.nl/', {
        headers: {
            'content-type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
            query: `
				query getApps {
					getApps {
						name
						description
						logoSrc
						homePageUrl
					}
				}
			`
        })
    }).then(response => response.json()).then(data => {
        if (data.errors) {
            throw new Error(data.errors[0].message);
        }

        document.querySelector('intergas-menu-modal').setAttribute(
            'apps', JSON.stringify(data.data.getApps)
        )
    });
}


$(document).ready(function () {

    new LuminousGallery($("img[hires]"), galleryOpts, luminousOpts);

    $('.sub-item-block').on('click', '.move-button', (evt) => {
        console.log('test ')
        var currentOrderValue = parseInt($(evt.target).closest('.sub-item-block').attr('data-order'));
        var nextOrderValue = currentOrderValue + 1;
        var prevOrderValue = parseInt(currentOrderValue - 1);

        var Current = $(evt.target).closest('.sub-item-block[data-order="' + currentOrderValue + '"]')

        var direction = $(evt.target).closest('button').attr('data-direction');
        if (direction == 'up') {
            Current.attr('data-order', Current.prev('.sub-item-block').attr('data-order'))
            Current.prev('.sub-item-block').attr('data-order', currentOrderValue)
        } else {
            Current.attr('data-order', Current.next('.sub-item-block').attr('data-order'))
            Current.next('.sub-item-block').attr('data-order', currentOrderValue)
        }

        $(evt.target).closest('.sub-items').find('.sub-item-block').sort(function (a, b) {
            return parseInt($(a).attr('data-order')) - parseInt($(b).attr('data-order'));
        }).appendTo($(evt.target).closest('.sub-items'));

    });

    $('#confirm-delete').on('show.bs.modal', function (e) {
        $(this).find('.btn-ok').attr('href', $(e.relatedTarget).data('href'));
    });


    $('.icp-auto').iconpicker({
        fontAwesome5: true,
    });

    $('.option').on('click', function (e) {
        e.stopPropagation();
    });

});


// window.Cookie = require('./cookieHelper.js');
// if( Cookie.Read('hideLabels') ){
// 	$(':root').css('--menuwidth', '65px');
// 	$('.compress i').delay(500).toggleClass('fa-less-than fa-thumbtack');
// }
// $('.compress').click(function(e){
// 	$('body').toggleClass('hideLabels');
// 	$('.compress i').delay(500).toggleClass('fa-less-than fa-thumbtack');
// 	if( $('body').hasClass('hideLabels')){
// 		Cookie.Create('hideLabels', true, 1);
// 	}else{
// 		Cookie.Erase('hideLabels');
// 	}
// });



// WEBPACK FOOTER //
// ./resources/js/app.js